module.exports = __webpack_public_path__ + "static/media/Banner_home.c7d93c2b.png";